export default __webpack_public_path__ + "static/media/image05.8883f6dc.png";